document.addEventListener('shopify:block:select', (event) => {
  // Open accordion on Block select
  const collapsible = event.target.hasAttribute('data-collapsible') ? event.target : null;
  if (collapsible && !collapsible?.hasAttribute('open')) {
    collapsible.querySelector('[data-collapsible-trigger]')?.dispatchEvent(new Event('click'));
  }

  // Select slide on Block select
  const blockSelectedIsSlide = event.target.hasAttribute('data-slide');
  if (blockSelectedIsSlide) {
    const slider = event.target.closest('[data-slider]');

    if (slider) {
      setTimeout(() => {
        slider.scrollTo({
          left: event.target.offsetLeft,
        });
      }, 200);
    }
  }

  // Pause ticker on block select
  const ticker = event.target.matches('ticker-bar') ? event.target : event.target.querySelector('ticker-bar') || event.target.closest('ticker-bar');
  if (ticker) {
    ticker.setAttribute('paused', '');
  }
});

document.addEventListener('shopify:block:deselect', (event) => {
  // Close accordion on Block deselect
  const collapsible = event.target.hasAttribute('data-collapsible') ? event.target : null;
  if (collapsible && collapsible.hasAttribute('open')) {
    collapsible.querySelector('[data-collapsible-trigger]')?.dispatchEvent(new Event('click'));
  }

  // Resume ticker on block deselect
  const ticker = event.target.matches('ticker-bar') ? event.target : event.target.querySelector('ticker-bar') || event.target.closest('ticker-bar');
  if (ticker) {
    ticker.removeAttribute('paused');
  }
});
